import { OpaqueToken } from '@angular/core';
export var NG_MAP_CONFIG_TOKEN = new OpaqueToken('NG_MAP_CONFIG_TOKEN');
//# sourceMappingURL=config.js.map


//////////////////
// WEBPACK FOOTER
// /Users/makebetter/Documents/sportsceneDash/~/@ngui/map/dist/services/config.js
// module id = ../../../../@ngui/map/dist/services/config.js
// module chunks = 4